// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

//Debug
// export const environment = {
//   production: true,
//   idCliente: 'SwDbag90KORPds0CkHDMPRH88NP2',
//   firebaseConfig: { //Colcoar servidor de produção
//     apiKey: "AIzaSyDMWVkdwd2pcdUukN6j1ZqCy8ivSB89wuo",
//     authDomain: "ipamenadistribuidoradebug.firebaseapp.com",
//     databaseURL: "https://ipamenadistribuidoradebug-default-rtdb.firebaseio.com",
//     projectId: "ipamenadistribuidoradebug",
//     storageBucket: "ipamenadistribuidoradebug.appspot.com",
//     messagingSenderId: "230940799412",
//     appId: "1:230940799412:web:b939579052c0871de542e1",
//     measurementId: "G-B3G3CXTKR6"
//   },
//   // apiBoletoUrl: 'https://localhost:5049/',
//   apiBoletoUrl: 'https://distribuidoraipanemaapi20230321173035.azurewebsites.net/',
//   //googleMapsClient: 'AIzaSyCF-mS8KuURqn5mjaPf0PfqoQahWxstwK8'
// };

//Produção
export const environment = {
  production: true,
  idCliente: 'mX6GE5LSX3aqEpNaLjECIDhHinv2',
  firebaseConfig: {
    apiKey: "AIzaSyA8AGT6yVb78YrDwHPLprPkqjYeaSKoZK4",
    authDomain: "ipanemadistribuidoraproducao.firebaseapp.com",
    projectId: "ipanemadistribuidoraproducao",
    storageBucket: "ipanemadistribuidoraproducao.appspot.com",
    messagingSenderId: "254385930857",
    appId: "1:254385930857:web:dab1d6e310b8fe31efd8f8",
    measurementId: "G-77EG1GYNWF"
  },
  // apiBoletoUrl: 'https://localhost:7182/api/Boletos',
  apiBoletoUrl: 'https://api.boletos.primenuvem.com.br/api/Boletos',
  //googleMapsClient: 'AIzaSyCF-mS8KuURqn5mjaPf0PfqoQahWxstwK8'
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
